import { render } from "./NewsPostView.vue?vue&type=template&id=5e1fa55f"
import script from "./NewsPostView.vue?vue&type=script&lang=js"
export * from "./NewsPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__